import {
    ILayoutData,
    IMasterData,
    ISlideData,
    IDrawingShapeData,
    INoteSlideData,
    IThemeData,
    ISectionData,
    IPresentationDataModel,
    ITableData,
    IGroupShapeData,
    ISmartArtData,
} from '@tencent/slide-sdk-model';
import { IUiDataService } from '@src/slide/domain/ui-model/service/ui-data-service.interface';
import { IResourceMapData } from '@tencent/slide-sdk-model/src/data/resource-map-data';

export enum CopiedKeyType {
    INHERIT = 'inheritedSdkData',
    OWN = 'ownSdkData',
}

export enum DataModel {
    textBodyModel,
    sdkModel
}

export enum CopyDataVersion {
    Version2 = 2,
    Version3 = 3
}

export interface ISlideSize {
    width: number;
    height: number;
}
export interface IClipboardData {
    data: ICopiedSdkData[];
    globalPadId: string; // 文档唯一标识
    slideSize?: ISlideSize; // 文档尺寸数据
    type: DataModel.sdkModel | DataModel.textBodyModel;
    sdkVersion?: CopyDataVersion;
    layoutList?: ICopiedLayoutData[]; // 版式数据
    masterList?: ICopiedMasterData[]; // 母版数据
    noteList?: ICopiedNoteSlideData[]; // 备注数据
    themeList?: ICopiedThemeData[]; // 主题数据
    resourceMap?: IResourceMapData; // 图片、音频、视频、字体 资源
}

export interface ISlideClipboardData extends IClipboardData {
    data: ICopiedSlideData[];
    layoutList: ICopiedLayoutData[]; // 版式数据
    masterList: ICopiedMasterData[]; // 母版数据
    noteList: ICopiedNoteSlideData[]; // 备注数据
    themeList: ICopiedThemeData[]; // 主题数据
    slideSize: ISlideSize; // 文档尺寸数据
}

export interface IReorganizeParams {
    clipboardData: IClipboardData;
    insertSlideIndex: number;
    sdkDataV3: IPresentationDataModel;
    slideSdkDataModify: ISlideSdkDataModify;
    uiDataService: IUiDataService;
}


export type ISdkData =
    | ISlideData
    | ILayoutData
    | IMasterData
    | INoteSlideData
    | IDrawingShapeData
    | IThemeData
    | ISectionData;

export interface ICopiedSdkData<T = ISdkData> {
    [CopiedKeyType.INHERIT]: T;
    [CopiedKeyType.OWN]: T;
}

export type ICopiedLayoutData = ICopiedSdkData<ILayoutData>;

export type ICopiedSlideData = ICopiedSdkData<ISlideData>;

export type ICopiedMasterData = ICopiedSdkData<IMasterData>;

export type ICopiedNoteSlideData = ICopiedSdkData<INoteSlideData>;

export type ICopiedShapeData = ICopiedSdkData<IDrawingShapeData>;

export type ICopiedThemeData = ICopiedSdkData<IThemeData>;

export type ICopiedTableData = ICopiedSdkData<ITableData>;

export type ICopiedGroupData = ICopiedSdkData<IGroupShapeData>;

export type ICopiedSectionData = ICopiedSdkData<ISectionData>;
export type ICopiedSmartArtData = ICopiedSdkData<ISmartArtData>;
export type ICopiedPageData = ICopiedSlideData | ICopiedLayoutData | ICopiedMasterData;

export interface ICopyInfo {
    clipboardData: IClipboardData,
    type: CopyElementType;
    firstElementDataId?: string;
    insertSlideIndex?: number; // 只是插入的slide的位置，不包含节
    insertGapIndex?: number; // 包含slide前面的节
}

export interface ISlideSdkDataModify {
    adjustPageData: (slideSDKData: ISlideData, slideSize: ISlideSize, notChangeLayout?: boolean) => void;
}

export enum ListName {
    THEME_LIST = 'themeList',
    MASTER_LIST = 'masterList',
    LAYOUT_LIST = 'layoutList',
    SLIDE_LIST = 'data',
}

export enum CopyElementType {
    SLIDE = 'slide',
    SHAPE = 'shape',
    TEXT = 'text'
}

export type ILayoutMap = Record<string, ILayoutData>;

export type INoteSlideMap = Record<string, INoteSlideData>;
